import BlSearchSectionMv from './BlSearchSectionMv.vue'

BlSearchSectionMv.install = function(Vue) {
  Vue.component(BlSearchSectionMv.name, BlSearchSectionMv)
}

export default BlSearchSectionMv
